import { render, staticRenderFns } from "./ExchangeRateList.vue?vue&type=template&id=4c8a8104&scoped=true"
import script from "./ExchangeRateList.vue?vue&type=script&lang=js"
export * from "./ExchangeRateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a8104",
  null
  
)

export default component.exports